/**
 * FiltrosPanel — filtros avancados do CRM (etapa, responsavel, origem),
 * dentro de um SlideOverPanel. Abre pelo botao "Filtros [N]" da barra.
 *
 * A lista de etapas vem por prop (derivada do board). A de responsaveis vem
 * de `useResponsaveisCrm` no CrmBoard (CRM-22): derivada dos cards, depois de
 * filtrar por "Ana" so sobrava a Ana, e vendedor sem lead nunca aparecia.
 * "Sem responsavel" (FORM-06) lista os leads que ninguem atribuiu ainda.
 * Origem usa o catalogo canonico ORIGENS_LEAD.
 */
import React from "react";

import SlideOverPanel from "../../components/SlideOverPanel";
import { ORIGENS_LEAD, SEM_RESPONSAVEL } from "../../services/crm";

import { Field, FormStack, Select } from "./styles";

function FiltrosPanel({
  open,
  onClose,
  filtros,
  onAplicar,
  onLimpar,
  etapas = [],
  responsaveis = [],
}) {
  const footer = (
    <>
      <button className="btn btn--secondary" type="button" onClick={onLimpar}>
        Limpar
      </button>
      <button className="btn btn--primary" type="button" onClick={onClose}>
        Aplicar
      </button>
    </>
  );

  return (
    <SlideOverPanel
      open={open}
      onClose={onClose}
      title="Filtros"
      subtitle="Refine o pipeline por etapa, responsável e origem"
      width="min(95vw, 420px)"
      footer={footer}
    >
      <FormStack>
        <Field>
          Etapa
          <Select
            value={filtros.etapa || ""}
            onChange={(e) => onAplicar("etapa", e.target.value)}
          >
            <option value="">Todas as etapas</option>
            {etapas.map((et) => (
              <option key={et.id} value={et.id}>
                {et.nome}
              </option>
            ))}
          </Select>
        </Field>

        <Field>
          Responsável
          <Select
            value={filtros.responsavel || ""}
            onChange={(e) => onAplicar("responsavel", e.target.value)}
          >
            <option value="">Todos os responsáveis</option>
            <option value={SEM_RESPONSAVEL}>Sem responsável</option>
            {responsaveis.map((r) => (
              <option key={r.id} value={r.id}>
                {r.nome}
              </option>
            ))}
          </Select>
        </Field>

        <Field>
          Origem
          <Select
            value={filtros.origem || ""}
            onChange={(e) => onAplicar("origem", e.target.value)}
          >
            <option value="">Todas as origens</option>
            {ORIGENS_LEAD.map((o) => (
              <option key={o.value} value={o.value}>
                {o.label}
              </option>
            ))}
          </Select>
        </Field>
      </FormStack>
    </SlideOverPanel>
  );
}

export default FiltrosPanel;
